import Swiper, {Navigation} from "swiper";

document.querySelectorAll(".one-type-logement").forEach(logement => {
    const modal = logement.querySelector('.modal-slider');

    const swiper = new Swiper(modal, {
        modules: [Navigation],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    modal.querySelector('.modal-slider__close').addEventListener('click', () => {
        modal.style.display = 'none';
        document.querySelector('body').style.overflow = '';
    });

    logement.querySelectorAll('.colimages img').forEach(img => {
        img.addEventListener('click', () => {
            swiper.slideTo(
                [...modal.querySelectorAll('.swiper-slide')].findIndex(slide => slide.dataset.image === img.dataset.image),
                0,
                false
            );
            modal.style.display = 'block';
            document.querySelector('body').style.overflow = 'hidden';
        });
    });
})
